import { InputField } from '@hakimo-ui/shared/ui-base';
import { EmployeeIdFilterValue } from '../types';

interface Props {
  value: EmployeeIdFilterValue;
  onChange: (value: EmployeeIdFilterValue) => void;
  placeholder?: string;
}

function EmployeeIdFilter(props: Props) {
  const { value, onChange, placeholder = 'Enter employee ID...' } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ value: e.target.value });
  };

  return (
    <InputField
      type="text"
      value={value?.value ?? ''}
      onChange={handleChange}
      placeholder={placeholder}
    />
  );
}

export default EmployeeIdFilter;
